var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "map-radius-slider d-flex align-items-center" },
    [
      _c("p", { staticClass: "text-nowrap text-grey" }, [
        _vm._v(_vm._s(_vm.text)),
      ]),
      _c("b-form-input", {
        staticClass: "mx-4",
        attrs: { type: "range", min: "5", max: "300", step: "5" },
        on: {
          change: function ($event) {
            return _vm.radiusValueChanged()
          },
        },
        model: {
          value: _vm.radius,
          callback: function ($$v) {
            _vm.radius = $$v
          },
          expression: "radius",
        },
      }),
      _c(
        "div",
        { staticClass: "number-input d-flex align-items-center rounded" },
        [
          _c("b-form-input", {
            staticClass: "p-1",
            attrs: {
              type: "number",
              min: "5",
              max: "300",
              step: "5",
              vertical: "",
            },
            on: {
              change: function ($event) {
                return _vm.radiusValueChanged()
              },
            },
            model: {
              value: _vm.radius,
              callback: function ($$v) {
                _vm.radius = $$v
              },
              expression: "radius",
            },
          }),
          _c("div", { staticClass: "pr-1" }, [_vm._v("km")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }